<template>
  <tr>
    <form-item-label label="ふりがな" :required="true" />
    <complemented-text-form
      v-if="complementedTextOpened"
      :text="complementedText"
      @open="openForm"
      :editable="editable"
    />

    <td v-if="!complementedTextOpened" colspan="3">
      <div
        class="m3p-contact__input m3p-contact__input_2column m3p-contact__name"
      >
        <last-name-kana-form
          :last-name-kana="lastNameKana"
          @change="(name, value) => changeValue(name, value)"
        />
        <first-name-kana-form
          :first-name-kana="firstNameKana"
          @change="(name, value) => changeValue(name, value)"
        />
      </div>
    </td>
  </tr>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import ComplementedTextForm from '@component_path/pages/pc/positions/show/common_components/form_element/ComplementedText';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';
import FirstNameKanaForm from '@component_path/pages/pc/positions/show/inquiry_form/components/inquiry_form_item/FirstNameKana';
import LastNameKanaForm from '@component_path/pages/pc/positions/show/inquiry_form/components/inquiry_form_item/LastNameKana';

const emit = defineEmits(['change']);

const props = defineProps({
  firstNameKana: {
    type: String,
    required: false,
    default: ''
  },
  lastNameKana: {
    type: String,
    required: false,
    default: ''
  },
  isLogged: {
    type: Boolean,
    required: true
  },
  editable: {
    type: Boolean,
    required: false,
    default: false
  }
});

const complementedTextOpened = ref(false);

const complementedText = computed(() => {
  return `${props.lastNameKana} ${props.firstNameKana}`;
});

const changeValue = (key, newValue) => {
  emit('change', key, newValue);
  if (key === 'last_name_kana') {
    emit('change', 'name_kana', `${newValue} ${props.firstNameKana}`);
  } else {
    emit('change', 'name_kana', `${props.lastNameKana} ${newValue}`);
  }
};
const openForm = () => (complementedTextOpened.value = false);

onMounted(() => {
  if (!!props.firstNameKana && !!props.lastNameKana) {
    complementedTextOpened.value = true;
  }
  if (!props.isLogged) {
    complementedTextOpened.value = false;
  }
});
</script>
